import React, { useEffect, useState } from "react";
import DropdownCustom from "../../components/DropdownCustom";
import CountriesJSON from "../../components/countries.json";
import DashboardService from "../../service/dashboard.service";
import UserService from "../../service/user.service";
import { Formik, useFormik } from "formik";
import * as yup from "yup";
import Swal from "sweetalert2";
import { DataTable } from "mantine-datatable";
import CustomPagination from "../../components/Layouts/CustomPagination";
import moment from "moment";
import { Pagination } from "@mantine/core";
import { IoIosNotifications } from "react-icons/io";
import * as ExcelJS from "exceljs";
// import { data } from "autoprefixer";

const Dashboard = () => {
  const [country, setCountry] = useState("");
  const [provider, setProvider] = useState("");
  // const [providerOptions, setProviderOptions] = useState([]);
  const [mccmncOptions, setMccMncOptions] = useState([]);
  console.log("mccmncOptions", mccmncOptions);

  const [countryOptions, setCountryOptions] = useState([]);
  const [generatedToken, setGeneratedToken] = useState("");
  const [mccMnc, setMccMnc] = useState("");
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [page, setPage] = useState(1);
  const PAGE_SIZES = [10, 20, 30, 50, 100];
  const [pageSize, setPageSize] = useState(PAGE_SIZES[0]);
  const [totalData, setTotalData] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isClicked, setIsClicked] = useState(false);

  const ALPHA_NUMERIC_STRING =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const SEGMENT_LENGTHS = [4, 7, 4, 8, 11, 8, 10, 4, 6];

  const schema = yup.object().shape({
    country: yup.mixed().required("Enter your Country"),
    mccMnc: yup.mixed().required("Enter your Mcc-Mnc"),
    // provider: yup.mixed().required("Enter your Provider"),
    numberOfUser: yup.number().required("Enter Number of Users"),
    // message: yup.string().required("Enter any message please"),
  });

  const initialValues = {
    country: "",
    // provider: "",
    numberOfUser: "",
    message: "",
    mccMnc: "",
    numberofuser: "",
  };

  const handleChange = (type, page) => {
    const total = totalData / pageSize;
    const newPage = Math.ceil(total);
    if (type === "Next") {
      if (page !== newPage) {
        setPage(page + 1);
      }
    } else if (type === "Previous") {
      if (page !== 1) {
        setPage(page - 1);
      }
    } else if (type === "First") {
      if (page !== 1) {
        setPage(1);
      }
    } else if (type === "Last") {
      if (page !== newPage) {
        setPage(newPage);
      }
    } else {
      setPage(page);
    }
  };

  const handleDataPerPage = (e) => {
    setPageSize(e.target.value);
  };

  const [sendTestNumber, setSendTestNumber] = useState("");
  const [generatedTestToken, setGeneratedTestToken] = useState("");

  // Small, non-intrusive corner toast (replaces the big center modals).
  const toast = (icon, title) =>
    Swal.fire({
      toast: true,
      position: "top-end",
      icon,
      title,
      showConfirmButton: false,
      timer: 2500,
      timerProgressBar: true,
    });

  const testNumber = () =>
    (sendTestNumber || data?.[0]?.mobileNumber || "").toString().replace(/\D/g, "");

  const handleGenerateToken = async () => {
    const n = testNumber();
    if (!n) {
      toast("warning", "Enter a mobile number, e.g. 66812345678");
      return;
    }
    try {
      const res = await UserService.generateTestToken(n);
      const token = res?.data?.apiresponse?.data?.token || "";
      setGeneratedTestToken(token);
      toast("success", "Token generated");
    } catch (error) {
      toast(
        "error",
        error?.response?.data?.apierror?.message || error.message || "Generate failed"
      );
    }
  };

  const handleSendTest = async () => {
    const n = (sendTestNumber || data?.[0]?.mobileNumber || "").toString().replace(/\D/g, "");
    if (!n) {
      toast("warning", "Enter a mobile number, e.g. 66812345678");
      return;
    }
    try {
      const res = await UserService.sendTest(n);
      const d = res?.data?.apiresponse?.data || {};
      if (d.token) setGeneratedTestToken(d.token); // show exactly what was sent
      let msgId = "";
      try {
        msgId = JSON.parse(d.gatewayResponse || "{}").message_id || "";
      } catch (_) {}
      if (msgId) {
        toast("success", `Sent to ${n} — gateway id ${msgId.slice(0, 10)}…`);
      } else {
        toast("warning", `Sent to ${n}, but gateway returned no message id`);
      }
    } catch (error) {
      toast(
        "error",
        error?.response?.data?.apierror?.message || error.message || "Send test failed"
      );
    }
  };

  const dashboardPushNotification = async () => {
    setLoading(true);
    try {
      const userIds = data.map((user) => user.id);
      const response = await DashboardService.dashboardPushNotification(
        userIds
      );
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"success"}`,
        },
      });

      toast.fire({
        title: "Notification sent successfully!",
      });
    } catch (error) {
      const toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 3000,
        showCloseButton: true,
        customClass: {
          popup: `color-${"danger"}`,
        },
      });

      toast.fire({
        title: error.message || "Failed to send notification",
      });
    } finally {
      setLoading(false);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: schema,
    onSubmit: async (values) => {
      const { country, mccMnc, numberOfUser } = values;

      try {
        const response = await DashboardService.getUsers(
          country,
          mccMnc,
          numberOfUser
        );
        setData(response?.data?.apiresponse?.data?.users);
        setTotalData(response.data.apiresponse.data.totalCount);
        console.log("setdatttttttt", response.data.apiresponse.data);
        setIsLoading(false);
        setIsClicked(true);
      } catch (error) {
        setIsLoading(false);
        const toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showCloseButton: true,
          customClass: {
            popup: `color-${"danger"}`,
          },
        });
        toast.fire({
          title: error,
        });
      }
    },
  });

  const getUsers = async (data) => {
    try {
      const body = data.map((item) => item.id);
      const response = await DashboardService.getUsersEveryTime(body);
      console.log("response?.data?.apiresponse?.data?.users", response);

      setData(response?.data?.apiresponse?.data?.users);
      setTotalData(response?.data?.apiresponse?.data?.count);
    } catch (error) {
      console.error("errrrr", error);
    }
  };

  useEffect(() => {
    if (isClicked) {
      const intervalId = setInterval(() => {
        getUsers(data);
      }, 3000);

      return () => clearInterval(intervalId);
    }
  }, [data]);

  const handleChangeCountry = async (e) => {
    setCountry(e); // Set the selected country
    formik.setFieldValue("country", e); // Update Formik country field
    formik.setFieldValue("provider", ""); // Clear provider field
    formik.setFieldValue("numberOfUser", ""); // Clear numberOfUser field
    setMccMnc(""); // Clear MCC/MNC selection
    setMccMncOptions([]); // Clear MCC/MNC options

    try {
      const response = await DashboardService.getMccMnc(e); // Fetch MCC/MNC data for the selected country
      const mccMncData = response.data.apiresponse.data;

      if (mccMncData && mccMncData.length > 0) {
        // Populate MCC/MNC dropdown options

        const options = mccMncData.map((item) => ({
          value: item,
          label: item,
        }));

        setMccMncOptions(options);
        // Optionally set the first MCC/MNC value by default
        const [mcc, mnc] = mccMncData[0].split("-");
        setMccMnc(`${mcc}-${mnc}`); // Set MCC/MNC to the first value
        formik.setFieldValue("mccMnc", `${mcc}-${mnc}`); // Set Formik value
      } else {
        console.error("No MCC/MNC data available.");
        setMccMncOptions([]); // Clear options if no data found
      }
    } catch (error) {
      console.error("Failed to fetch MCC/MNC data:", error);
    }
  };

  const handleChangeMccMnc = (e) => {
    setMccMnc(e);
    formik.setFieldValue("mccMnc", e);
    console.log("Selected MCC/MNC:", e);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await DashboardService.getCountry();
        const countries = response.data.apiresponse.data;
        const options = countries.map((item) => ({
          value: item,
          label: item,
        }));
        setCountryOptions(options);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    fetchCountries();
  }, []);

  // Function to generate a token
  const generateToken = () => {
    const tokenSegments = SEGMENT_LENGTHS.map((length) =>
      generateSegment(length)
    );
    const token = tokenSegments.join(" ");
    const digits = getFiveDigitsSummingTo32();
    const finalToken = insertDigitsIntoToken(token, digits);
    formik.setFieldValue("message", finalToken);
    setGeneratedToken(finalToken);
  };

  const generateSegment = (length) => {
    let segment = "";
    for (let i = 0; i < length; i++) {
      const index = Math.floor(
        Math.random() * (ALPHA_NUMERIC_STRING.length - 10)
      );
      segment += ALPHA_NUMERIC_STRING.charAt(index);
    }
    return segment;
  };

  const getFiveDigitsSummingTo32 = () => {
    const digits = [];
    let sum = 32;

    for (let i = 0; i < 4; i++) {
      const digit = Math.floor(Math.random() * (9 - 6 + 1)) + 6;
      digits.push(digit);
      sum -= digit;
    }
    digits.push(sum);
    return digits;
  };

  const insertDigitsIntoToken = (token, digits) => {
    const digitPositions = [];
    const tokenArray = token.split("");

    tokenArray.forEach((char, index) => {
      if (char !== " ") {
        digitPositions.push(index);
      }
    });

    for (let i = digitPositions.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [digitPositions[i], digitPositions[j]] = [
        digitPositions[j],
        digitPositions[i],
      ];
    }

    digits.forEach((digit, i) => {
      tokenArray[digitPositions[i]] = digit.toString();
    });

    return tokenArray.join("");
  };

  const handleExportExcel = async () => {
    let totalAmount = 0;
    let totalBeforeAmount = 0;
    let totalAfterAmount = 0;
    for (let i = 0; i < data?.length; i++) {
      totalAmount += parseFloat(data[i]?.amount);
      totalBeforeAmount += parseFloat(data[i]?.beforeAmount);
      totalAfterAmount += parseFloat(data[i]?.afterAmount);
    }

    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Sheet1");

    const commonCellStyle = {
      fill: {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "CCCCCC" },
      },
      border: {
        top: { style: "thin", color: { argb: "000000" } },
        left: { style: "thin", color: { argb: "000000" } },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "thin", color: { argb: "000000" } },
      },
      font: { color: { argb: "000000" }, bold: true },
    };

    const titleRow = worksheet.addRow(["Twin-box Users"]);
    worksheet.mergeCells("A1:J1");

    titleRow.getCell(1).font = { ...commonCellStyle.font, size: 12 };
    worksheet.addRow([]);
    worksheet.mergeCells("A2:J2");

    // Add column headers
    const headers = [
      "ID",
      "Mobile No.",
      "Country Code",
      "Country Name",
      "MCC",
      "MNC",
      "Mobile Network Name",
      "Installation Date",
      "Last Active Date",
      "Status",
    ];
    worksheet.getColumn(1).width = 20; // Column N
    worksheet.getColumn(2).width = 30; // Column Card
    worksheet.getColumn(3).width = 20;
    worksheet.getColumn(4).width = 25;
    worksheet.getColumn(5).width = 22;
    worksheet.getColumn(6).width = 25; // Column N
    worksheet.getColumn(7).width = 25; // Column Card
    worksheet.getColumn(8).width = 30;
    worksheet.getColumn(9).width = 25;
    worksheet.getColumn(10).width = 20;

    const headerRow = worksheet.addRow(headers);
    headerRow.getCell(1).alignment = { horizontal: "center" };
    headerRow.getCell(2).alignment = { horizontal: "center" };
    headerRow.getCell(3).alignment = { horizontal: "center" };
    headerRow.getCell(4).alignment = { horizontal: "center" };
    headerRow.getCell(5).alignment = { horizontal: "center" };
    headerRow.getCell(6).alignment = { horizontal: "center" };
    headerRow.getCell(7).alignment = { horizontal: "center" };
    headerRow.getCell(8).alignment = { horizontal: "center" };
    headerRow.getCell(9).alignment = { horizontal: "center" };
    headerRow.getCell(10).alignment = { horizontal: "center" };

    headerRow.eachCell((cell) => {
      cell.border = {
        top: { style: "none" },
        left: { style: "none" },
        bottom: { style: "thin", color: { argb: "000000" } },
        right: { style: "none" },
      };
    });

    // Add data rows
    data.forEach((res, index) => {
      const table = worksheet.addRow([
        (page - 1) * pageSize + index + 1,
        res.mobileNumber ? res.mobileNumber : "--",
        res.countryCode ? res.countryCode : "--",
        res.country ? res.country : "--",
        res.mcc ? res.mcc : "--",
        res.mnc ? res.mnc : "--",
        res.networkName ? res.networkName : "--",
        res.creationDate !== "0" &&
        res.creationDate !== 0 &&
        res.creationDate !== "" &&
        res.creationDate !== null &&
        res.creationDate !== undefined &&
        res.creationDate !== "null"
          ? moment(Number(res.creationDate)).format("DD/MM/YYYY HH:mm")
          : "--",
        res.lastActiveDate !== "0" &&
        res.lastActiveDate !== 0 &&
        res.lastActiveDate !== "" &&
        res.lastActiveDate !== null &&
        res.lastActiveDate !== undefined &&
        res.lastActiveDate !== "null"
          ? moment(Number(res.lastActiveDate)).format("DD/MM/YYYY HH:mm")
          : "--",
        res.isOnline ? res.isOnline : "--",
      ]);
      table.getCell(1).alignment = { horizontal: "center" };
      table.getCell(2).alignment = { horizontal: "center" };
      table.getCell(3).alignment = { horizontal: "center" };
      table.getCell(4).alignment = { horizontal: "center" };
      table.getCell(5).alignment = { horizontal: "center" };
      table.getCell(6).alignment = { horizontal: "center" };
      table.getCell(7).alignment = { horizontal: "center" };
      table.getCell(8).alignment = { horizontal: "center" };
      table.getCell(9).alignment = { horizontal: "center" };
      table.getCell(10).alignment = { horizontal: "center" };
      table.eachCell((cell) => {
        cell.border = {
          top: { style: "none" },
          left: { style: "none" },
          bottom: { style: "none" },
          right: { style: "none" },
        };
      });
    });

    worksheet.addRow([]);
    worksheet.addRow([]);

    // Create an Excel file
    const buffer = await workbook.xlsx.writeBuffer();

    // Download the file
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = "Users.xlsx";
    link.click();
  };

  return (
    <div className="space-y-5">
      {/* Header */}
      <div>
        <h5 className="text-xl font-semibold dark:text-white-light">Dashboard</h5>
        <p className="text-sm text-gray-500">
          Find enrolled test devices and run covert delivery tests.
        </p>
      </div>

      {/* Top row: two side-by-side cards */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        {/* Card 1 — Find test devices */}
        <form
          onSubmit={formik.handleSubmit}
          className="rounded-lg border border-gray-200 bg-white shadow-sm p-5 dark:bg-[#0e1726] dark:border-gray-700"
        >
          <h6 className="font-semibold mb-4 dark:text-white-light">Find Test Devices</h6>

          <div className="mb-4">
            <label className="text-sm font-medium block mb-1.5 text-gray-600 dark:text-gray-300">
              Country
            </label>
            {countryOptions.length > 0 && (
              <DropdownCustom
                data={countryOptions}
                setData={handleChangeCountry}
                name="Country"
              />
            )}
            {formik.errors.country && formik.touched.country && (
              <div className="text-red-500 text-xs mt-1">{formik.errors.country}</div>
            )}
          </div>

          <div className="mb-4">
            <label className="text-sm font-medium block mb-1.5 text-gray-600 dark:text-gray-300">
              MCC &amp; MNC
            </label>
            <DropdownCustom
              className="border rounded p-2"
              data={mccmncOptions}
              setData={handleChangeMccMnc}
              name="Mcc-Mnc"
              value={mccMnc}
            />
            {formik.errors.mccMnc && formik.touched.mccMnc && (
              <div className="text-red-500 text-xs mt-1">{formik.errors.mccMnc}</div>
            )}
          </div>

          <div className="mb-5">
            <label className="text-sm font-medium block mb-1.5 text-gray-600 dark:text-gray-300">
              Number of Users
            </label>
            <input
              type="number"
              placeholder="e.g. 3"
              className="border rounded p-2 w-full dark:bg-[#1b2e4b] dark:border-gray-700"
              onChange={formik.handleChange}
              value={formik.values.numberOfUser}
              name="numberOfUser"
            />
            {formik.errors.numberOfUser && formik.touched.numberOfUser && (
              <div className="text-red-500 text-xs mt-1">{formik.errors.numberOfUser}</div>
            )}
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white rounded-md px-4 py-2.5 font-medium hover:bg-blue-600 transition"
          >
            Find Available Users
          </button>
        </form>

        {/* Card 2 — Delivery test */}
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm p-5 dark:bg-[#0e1726] dark:border-gray-700">
          <h6 className="font-semibold dark:text-white-light">Delivery Test</h6>
          <p className="text-sm text-gray-500 mb-4">
            Generate a covert token, or send a live test SMS to a specific number.
          </p>

          <label className="text-sm font-medium block mb-1.5 text-gray-600 dark:text-gray-300">
            Test number (international)
          </label>
          <input
            type="text"
            value={sendTestNumber}
            onChange={(e) => setSendTestNumber(e.target.value)}
            placeholder="e.g. 66812345678"
            className="border rounded p-2 w-full mb-3 dark:bg-[#1b2e4b] dark:border-gray-700"
          />

          <div className="flex gap-2">
            <button
              type="button"
              className="flex-1 bg-gray-700 text-white rounded-md px-4 py-2.5 font-medium hover:bg-gray-800 transition"
              onClick={handleGenerateToken}
            >
              Generate Token
            </button>
            <button
              type="button"
              className="flex-1 bg-green-600 text-white rounded-md px-4 py-2.5 font-medium hover:bg-green-700 transition"
              onClick={handleSendTest}
            >
              Send Test
            </button>
          </div>

          {generatedTestToken && (
            <div className="mt-4">
              <label className="text-xs font-medium text-gray-500 block mb-1">
                Generated token (send as the SMS body)
              </label>
              <div className="flex gap-2">
                <input
                  readOnly
                  value={generatedTestToken}
                  onFocus={(e) => e.target.select()}
                  className="flex-1 border rounded px-2 py-2 font-mono text-xs bg-gray-50 dark:bg-[#1b2e4b] dark:border-gray-700"
                />
                <button
                  type="button"
                  className="bg-gray-200 hover:bg-gray-300 rounded px-4 text-sm font-medium dark:bg-gray-700 dark:text-white"
                  onClick={() => {
                    navigator.clipboard.writeText(generatedTestToken);
                    Swal.fire({
                      toast: true,
                      position: "top-end",
                      icon: "success",
                      title: "Copied",
                      showConfirmButton: false,
                      timer: 1200,
                    });
                  }}
                >
                  Copy
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {/* Results card — only after a search */}
      {data?.length > 0 && (
        <div className="rounded-lg border border-gray-200 bg-white shadow-sm dark:bg-[#0e1726] dark:border-gray-700">
          <div className="flex flex-wrap items-center justify-between gap-3 p-4 border-b border-gray-200 dark:border-gray-700">
            <h6 className="font-semibold dark:text-white-light">
              Enrolled Devices{" "}
              <span className="text-gray-400 font-normal">({totalData})</span>
            </h6>
            <div className="flex gap-2">
              <button
                type="button"
                className="bg-blue-500 text-white rounded-md px-4 py-2 text-sm font-medium hover:bg-blue-600 transition disabled:opacity-60"
                onClick={dashboardPushNotification}
                disabled={loading}
              >
                {loading ? "Notifying…" : "Notify (wake)"}
              </button>
              <button
                type="button"
                className="border border-gray-300 text-gray-700 rounded-md px-4 py-2 text-sm font-medium hover:bg-gray-50 transition dark:text-gray-200 dark:border-gray-600 dark:hover:bg-[#1b2e4b]"
                onClick={handleExportExcel}
              >
                Export Excel
              </button>
            </div>
          </div>

          <div className="overflow-x-auto p-2">
            <DataTable
              noRecordsText="No results match your search query"
              highlightOnHover
              className="whitespace-nowrap table-hover"
              records={data}
              columns={[
                {
                  accessor: "id",
                  title: "#",
                  render: (_row, index) => (
                    <span>{(page - 1) * pageSize + index + 1}</span>
                  ),
                },
                {
                  accessor: "mobileNumber",
                  title: "Mobile No.",
                  render: ({ mobileNumber }) => (
                    <span className="font-medium">{mobileNumber}</span>
                  ),
                },
                {
                  accessor: "networkName",
                  title: "Network",
                  render: ({ networkName }) => (
                    <span className="text-xs">{networkName || "--"}</span>
                  ),
                },
                {
                  accessor: "mcc",
                  title: "MCC-MNC",
                  render: ({ mcc, mnc, country }) => (
                    <span className="text-xs text-gray-500">
                      {country ? country + " · " : ""}
                      {mcc ?? "-"}-{mnc ?? "-"}
                    </span>
                  ),
                },
                {
                  accessor: "lastActiveDate",
                  title: "Last Active",
                  render: ({ lastActiveDate }) => (
                    <span className="text-xs">
                      {lastActiveDate &&
                      lastActiveDate !== "0" &&
                      lastActiveDate !== 0 &&
                      lastActiveDate !== "null"
                        ? moment(Number(lastActiveDate)).format("DD/MM/YYYY HH:mm")
                        : "--"}
                    </span>
                  ),
                },
                {
                  accessor: "isOnline",
                  title: "Status",
                  render: ({ isOnline }) => (
                    <span
                      className={`${
                        isOnline
                          ? "text-success bg-success/15"
                          : "text-danger bg-warning/15"
                      } rounded-full px-3 py-1 text-xs font-bold`}
                    >
                      {isOnline ? "Online" : "Offline"}
                    </span>
                  ),
                },
              ]}
              totalRecords={totalData}
              recordsPerPage={pageSize}
              onPageChange={(p) => setPage(p)}
              recordsPerPageOptions={PAGE_SIZES}
              onRecordsPerPageChange={setPageSize}
              minHeight={160}
            />
          </div>

          <div className="p-4 border-t border-gray-200 dark:border-gray-700">
            <CustomPagination
              total={totalData}
              page={page}
              handleChange={handleChange}
              dataPerPage={pageSize}
              handleDataPerPage={handleDataPerPage}
              PAGE_SIZES={PAGE_SIZES}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default Dashboard;
